import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import WebfontLoader from '@dr-kobros/react-webfont-loader';
import registerServiceWorker from './registerServiceWorker';

// webfontloader configuration object.
const config = {
	google: {
		families: ['Barlow:200i,300i,400,400i,500,500i,600i,700,700i,900i', 'Yrsa:300,400,600,700']
	}
};
// Callback receives the status of the general webfont loading process. *OPTIONAL*
const callback = status => {
  // I could hook the webfont status to for example Redux here.
};

ReactDOM.render(
	<WebfontLoader config={config} onStatus={callback}>
		<App />
	</WebfontLoader>,
	document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js